import type { EffectCallback } from "react";
import { useEffect, useRef } from "react";

export const useUnmount = (callback: EffectCallback) => {
    const funcRef = useRef(callback);

    funcRef.current = callback;

    useEffect(
        () => (): void => {
            funcRef.current();
        },
        [],
    );
};
